export const supportsKeepAlive = "keepalive" in new Request("https://readyly.com");
